import { SocketService } from '../../../libs/socket/socket_service'
import { IVersionInfo, SocketConfig } from '../response'
import i18n, { isLangFromStorage, updateLanguage } from '@/languages/i18n'
import { isElectron } from '@libs/utils/envUtils'
import { Brand } from '@/brand/brand'
import { HelperSocketMsg, HelperSocketMsgType } from './message'
import { errorMessages } from '../error_messages'
import { DialogType, enableDialog } from '@/components/cdialog/dialog'

const { t } = i18n.global

export class HelperService {
  public static instance = new HelperService()
  socketService: SocketService = new SocketService({
    autoReconnect: false,
  })
  constructor() {
    if (import.meta.env.PROD) {
      if (!isElectron()) return
    }
    this.initSocketConnection()
  }

  private initSocketConnection() {
    this.socketService.connect(new WebSocket('ws://127.0.0.1:7678'))
    this.socketService.setMsgErrorCallback(this.showErrorNotification)
    this.socketService.setEventHandlers({
      onOpen: (_event) => this.register(),
    })
  }

  private showErrorNotification(errMessage: string) {
    const errMsg = errorMessages[errMessage] ? t(errorMessages[errMessage].i18n) : errMessage
    enableDialog(errMsg, DialogType.notice, false)
  }

  private setLang = async () => {
    const cfg = await this.getConfig()
    updateLanguage(cfg.AstLanguage)
  }

  private onReceivedBrand: ((res: Brand) => void)[] = []
  private _initBrand: null | Brand = null

  callbackOfBrand = (fn: (bd: Brand) => void) => {
    if (this._initBrand != null) {
      fn(this._initBrand)
    } else {
      this.onReceivedBrand.push(fn)
    }
  }

  private onRegistered() {
    const data = {
      Type: HelperSocketMsgType.MsgTypeAppMsgType,
      Data: 'msgtype',
    } as HelperSocketMsg<any>
    this.socketService.askTypeAndData<Brand>(data).then((res: Brand) => {
      this._initBrand = res
      this.onReceivedBrand.forEach((fn) => {
        fn(res)
      })
    })
  }
  register() {
    this.socketService.setHandler(HelperSocketMsgType.MsgTypeRegister, () => {
      this.onRegistered()
      this.askDriverService()
      this.listenToDeviceChange()
      if (!isLangFromStorage) {
        this.setLang()
      }
    })

    const data = {
      Type: HelperSocketMsgType.MsgTypeRegister,
      Data: 'driver_script',
    } as HelperSocketMsg<any>
    this.socketService.ask(data)
  }

  private async getConfig(): Promise<SocketConfig> {
    const data = {
      Type: HelperSocketMsgType.MsgTypeConfigure,
    } as HelperSocketMsg<any>
    return await this.socketService.ask<SocketConfig>(data)
  }

  private listenToDeviceChange() {
    this.socketService.setHandler(
      HelperSocketMsgType.MsgTypeStateChanged,
      (res: HelperSocketMsgType) => {
        this.onStateChanged(res)
      },
      (err: string) => {
        console.log('MsgTypeStateChanged:', err)
      },
    )
  }

  private onStateChanged(state: HelperSocketMsgType) {
    switch (state) {
      case HelperSocketMsgType.MsgTypeConfigure:
        this.getConfig().then((res) => {
          updateLanguage(res.AstLanguage)
        })
        break
    }
  }

  private askDriverService() {
    return this.askLastVersion<IVersionInfo>('driver_service')
  }

  async askLastVersion<T>(application: string) {
    const data = {
      Type: HelperSocketMsgType.MsgTypeLatestVersion,
      Data: application,
    } as HelperSocketMsg<any>
    return await this.socketService.askTypeAndData<T>(data)
  }

  launchEEvision() {
    this.launchNcus_i()
    setTimeout(() => (window as any).require('electron').ipcRenderer.send('close'), 2000)
  }

  private launchNcus_i() {
    const launch = {
      Type: HelperSocketMsgType.MsgTypeLaunch,
      Data: 'ncus_i',
    } as HelperSocketMsg<any>
    this.socketService.ask(launch)
  }

  public launchDriverService(): Promise<void> {
    const launch = {
      Type: HelperSocketMsgType.MsgTypeLaunch,
      Data: 'driver_service',
    } as HelperSocketMsg<any>
    return this.socketService.ask(launch)
  }
}
